import { render, staticRenderFns } from "./TsBranchExpireContract.vue?vue&type=template&id=90513be8&scoped=true&"
import script from "./TsBranchExpireContract.vue?vue&type=script&lang=js&"
export * from "./TsBranchExpireContract.vue?vue&type=script&lang=js&"
import style0 from "./TsBranchExpireContract.vue?vue&type=style&index=0&id=90513be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90513be8",
  null
  
)

export default component.exports